import { PersonOutlineOutlined } from "@mui/icons-material";
import { Box, Typography, Stack } from "@mui/material";
import { Auth0WithOutRedirect } from "../../services/Utilities";

export const LoginUser = (props: any) => {
    const { organizationSettings } = props;

    return (
        <Box onClick={() => Auth0WithOutRedirect.show()}
            sx={{
                marginBottom: '20px',
                padding: '6px 15px',
                border: '1px solid',
                borderColor: organizationSettings?.layoutColor,
                borderRadius: '100px',
                fontSize: '14px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                display: 'flex',
                width: 'fit-content',
                marginLeft: 'auto',
            }}
        >
            <Stack direction="row" alignItems="center" ml={"auto"}>
                <PersonOutlineOutlined color="secondary" sx={{ fontSize: '22px', marginRight: '5px' }} />
                <Typography sx={{ fontSize: { sm: '14px' } }}>Sign in</Typography>
            </Stack>
        </Box>
    )
};